/**
 * @link https://span.studio
 * @copyright Copyright (c) Span Studio LLC
 * @license https://github.com/Span-Studio/sta100-craft5/blob/main/LICENSE.md
 * 
 * Entry Delete.
 * UI and Fetch routine for deleting a submission entry. 
 * 
 * @author John Pobojewski <https://john.pobojewski.com>
 */

import Modal from "/src/scripts/components/Modal.js";

class EntryDelete {
	init() {
		console.log("EntryDelete: init()");

		const buttons = document.querySelectorAll("[data-action=delete-entry]");
		buttons.forEach((button) => {
			button.addEventListener("click", (event) => {
				Modal.interrupt(button, (e) => this.deleteEntry(e));
			});
		});
	}

	deleteEntry(deleteButton) {
		Modal.dismiss();

		const dataId = deleteButton.getAttribute("data-entry-id");
		console.log("EntryDelete.deleteEntry(): " + dataId);

		const data = new URLSearchParams();
		data.append("entryId", parseInt(dataId));
		data.append(csrfTokenName, csrfTokenValue);

		const spinner = document.createElement("span");
		spinner.className = "spinner";
		spinner.innerHTML = '<span>Deleting...</span>';
		deleteButton.replaceWith(spinner);

		fetch('actions/sta100/run/delete-entry', {
			method: "POST",
			headers: { "Content-Type": "application/x-www-form-urlencoded" },
			body: data
		})
	    .then(response => response.json())
	    .then(response => {
			if (response.success) {
				const entry = document.querySelector(`.entry[data-entry-id="${dataId}"]`);
				if (entry) {
					entry.style.transition = "opacity 0.5s";
					entry.style.opacity = "0";
					setTimeout(() => {
						entry.remove();
						window.location.reload(true);
					}, 500);
				}
			} else {
				console.log(response);
			}
		})
		.catch((err) => {
			console.error("Error deleting entry:", err);
		});
	}
}

export default new EntryDelete();
